
export const centeredContent = `w-full flex-1 flex flex-col items-center justify-center`;

export const whiteBox = `bg-white rounded-lg shadow-2xl flex flex-col items-center p-10 2xl:p-16 md:my-4 md:mr-8 2xl:mr-10 w-full md:max-w-[30vw] 2xl:max-w-[28vw]`;